import { expVal, expValEquals } from '@confluence/feature-experiments';
import type {
	ReactionsConfluenceSaveReactionMutation,
	ReactionsDeleteReactionMutation,
	ReactionsMutationResultsData,
} from '@confluence/reactions/entry-points/reactionTypes.ts';
import { CommentType } from '@confluence/comments-data/entry-points/useCommentsData.ts';
import type { EditCommentUpdateCommentMutation_Mutation } from '../__types__/EditCommentUpdateCommentMutation.ts';

// Function overloads for better type safety
export function getOptimisticResponse(params: {
	ari: string;
	containerAri: string;
	emojiId: string;
	action: 'add';
}): ReactionsConfluenceSaveReactionMutation | undefined;

export function getOptimisticResponse(params: {
	ari: string;
	containerAri: string;
	emojiId: string;
	action: 'delete';
}): ReactionsDeleteReactionMutation | undefined;

export function getOptimisticResponse({
	ari,
	containerAri,
	emojiId,
	action,
}: {
	ari: string;
	containerAri: string;
	emojiId: string;
	action: 'add' | 'delete';
}): ReactionsMutationResultsData | undefined {
	if (!expValEquals('confluence_comments_tuneup', 'isEnabled', true)) {
		return undefined;
	}

	if (action === 'add') {
		return {
			__typename: 'Mutation',
			confluence_addReaction: {
				__typename: 'ConfluenceReactionPayload',
				ari,
				containerAri,
				emojiId,
			},
		} as ReactionsConfluenceSaveReactionMutation;
	} else {
		return {
			__typename: 'Mutation',
			deleteReaction: {
				__typename: 'SaveReactionResponse',
				ari,
				containerAri,
				emojiId,
			},
		} as ReactionsDeleteReactionMutation;
	}
}

export function getEditCommentOptimisticResponse({
	commentId,
	commentType,
	adfString,
	sessionDisplayName,
}: {
	commentId: string;
	commentType: CommentType;
	adfString: string;
	sessionDisplayName: string | null;
}): EditCommentUpdateCommentMutation_Mutation | undefined {
	if (
		commentType === CommentType.GENERAL ||
		!expVal('cc_comments_new_comments_data_manager', 'isEnabled', false) ||
		!expVal('confluence_comments_optismistic_edit', 'isEnabled', false)
	) {
		return undefined;
	}

	return {
		updateComment: {
			id: commentId,
			body: {
				value: adfString,
			},
			version: {
				number: null,
				when: new Date().toISOString(),
				by: {
					displayName: sessionDisplayName,
				},
			},
		},
	};
}
